import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Row from "react-bootstrap/Row";
import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { locale } from "dayjs/locale/th";

dayjs.extend(buddhistEra);
dayjs.locale("th");
// import Col from "react-bootstrap/Col";
// import moment from 'moment';
import("../assets/css/activities.css");

export default function Activities() {
    // const apiUrl = "http://10.1.245.45/api/activityDBMS/?limit=8&owner=arch";
    // const apiUrl = process.env.REACT_APP_ACT_API_URL;
    // https://aed.mju.ac.th/api/ActivityDBMS/v1/arch/web/5
    // const apiUrl = `https://aed.mju.ac.th/api/actdbms`;
    const apiUrl = `https://aed.mju.ac.th/api/ActivityDBMS`;
    const [activities, setActivities] = useState([]);
    const [isloading, setIsloading] = useState(true);
    // const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0"; // old url
    const apiKey =
        "551a781fa2e203b0c834f7dcb94789d1aab6c627462be4b77968b73d5588fbf1ecc30e1e02e18ee5"; // new url

    const genActivityCards = activities.map((act, index) => {
        const d = dayjs(act.act_date).format("YYYY-MM-DD");
        const act_date = dayjs(act.act_date).format("DD MMM BB");
        return (
            <div key={`cardHolder-${index}`} className="activityCardHolder">
                <div className="card">
                    <img
                        // src={`${process.env.REACT_APP_ACTDBMS_URL}uploads/activity/${d}_${act.act_code}/${act.act_poster}`}
                        // src={
                        //     act.act_poster.startsWith("http://") ||
                        //     act.act_poster.startsWith("https://")
                        //         ? act.act_poster
                        //         : `https://aed.mju.ac.th/ActivityDBMS/uploads_activity/${d}_${act.act_code}/${act.act_poster}`
                        // }
                        src={act.act_poster}
                        className="card-img-top"
                        alt={act.act_title}
                        height={180}
                        style={{ objectFit: "cover" }}
                    />
                    <div className="card-body w-100">
                        <h5 className="card-title">{act.act_title}</h5>
                        <Link
                            to={`/news/${act.act_code}`}
                            className="btn btn-outline-light mt-2"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {"อ่านเพิ่มเติม >> "}
                        </Link>
                    </div>
                    <div className="card-footer">
                        <p>
                            <i className="bi bi-clock me-2"></i> {act_date}
                        </p>
                    </div>
                </div>
            </div>
        );
    });

    useEffect(() => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + apiKey,
        };
        const fetchData = async () => {
            console.error('axios url:', `${apiUrl}/v1/arch/web/8/`);
            try {
                const result = await axios.get(
                    // `${apiUrl}/v1/arch/limit/8/actdbms`,
                    `${apiUrl}/v1/arch/web/8`,
                    headers,
                );
                // const result = await axios.get(apiUrl);
                setActivities(result.data);
                setIsloading(false);
                // console.log("datails: ", activities);
            } catch (e) {
                console.log("headers: ", headers);
                console.error("fetch ERROR: ", e);
                setIsloading(true);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {isloading && <div>กำลังโหลดข่าวกิจกรรม...</div>}
            {!isloading && (
                <div className="px-3 activity">
                    <div
                        className="activitySectionTitle"
                        style={{
                            textAlign: "center",
                            color: "#603b2c",
                            margin: "60px 0 20px 0",
                            fontSize: "36px",
                        }}
                    >
                        ...กิจกรรมคณะฯ...
                    </div>
                    <Row
                        xs={1}
                        sm={2}
                        md={3}
                        lg={4}
                        className="justify-content-between"
                    >
                        {genActivityCards}
                    </Row>
                    <div className="text-end pe-4">
                        <a
                            href={`${process.env.REACT_APP_ACTDBMS_URL}report/template.php?owner=ARCH&t=calendar&y=${new Date().getFullYear()}&act=report`}
                            target="_blank"
                            rel="noreferrer"
                            className="link-info fs-6 text-decoration-none"
                        >
                            {"ข่าวกิจกรรมคณะทั้งหมด >>"}
                        </a>
                    </div>
                </div>
            )}
        </>
    );
}

// function Activities2() {
//   // const apiUrl = "https://ict.mju.ac.th/api/_train_regis_ext.php?method=get&round_no=2024-01-11_20857059";
//   // const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";
//   // const apiUrl = "https://faed.mju.ac.th/ActivityDBMS/_api?limit=6&owner=arch";
//   const apiUrl = "https://aed.mju.ac.th/api/activityDBMS/?limit=8&owner=arch";
//   // const apiUrl = "https://ict.mju.ac.th/api/_train_regis_ext.php?method=get&round_no=2024-01-11_20857059";
//   // const apiUrl = "https://65758485b2fbb8f6509d2e54.mockapi.io/activity/activityies";
//   const [activities, setActivities] = useState([]);
//   const [isloading, setIsloading] = useState(true);
//   const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";

//   const genActivityCards = activities.map((act, index) => {
//     return (
//       <div key={`cardHolder-${index}`} className="activityCardHolder">
//         <div className="card w-100">
//           <img
//             src={`https://faed.mju.ac.th/ActivityDBMS/uploads/activity/${act.act_date}_${act.act_code}/${act.act_poster}`}
//             className="card-img-top"
//             alt="Description of your "
//             height={200}
//           />
//           <div className="card-body">
//             <h5 className="card-title">{act.act_title}</h5>
//             <Link
//               to={`/news/${act.act_code}`}
//               className="btn btn-outline-light mt-2"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               {"อ่านเพิ่มเติม >> "}
//             </Link>
//           </div>
//           <div className="card-footer">
//             <p>
//               <i className="bi bi-clock"></i> {act.act_date}
//             </p>
//           </div>
//         </div>
//       </div>
//     );
//   });

//   useEffect(() => {
//     const headers = {
//       "Content-Type": "application/json",
//       Authorization: apiKey,
//     };
//     const fetchData = async () => {
//       try {
//         const result = await axios.get(apiUrl, headers);
//         // const result = await axios.get(apiUrl);
//         setActivities(result.data);
//         setIsloading(false);
//         // console.log("datails: ", activities);
//       } catch (e) {
//         console.error("fetch ERROR: ", e);
//         setIsloading(true);
//       }
//     };

//     fetchData();
//     // eslint-disable-next-line
//   }, []);

//   return (
//     <>
//       {isloading && <div>กำลังโหลดข่าวกิจกรรม...</div>}
//       {!isloading && (
//         <div className="px-3 activity">
//           <div
//             className="text-center mb-0"
//             style={{
//               color: "#603b2c",
//               margin: "60px 0 20px 0",
//               fontSize: "36px",
//             }}
//           >
//             ...กิจกรรมคณะฯ...
//           </div>
//           <div
//             className="row row-cols-1 row-cols-md-3 row-cols-xl-4 g-5 mx-auto"
//             style={{
//               justifyContent: "space-around",
//               marginTop: "10px",
//             }}
//           >
//             {/* {console.log("activities: ", activities)} */}
//             {genActivityCards}
//           </div>
//           <div className="text-end pe-4">
//             <a
//               href="https://faed.mju.ac.th/ActivityDBMS/report/template.php?owner=ARCH&t=calendar&y=2023&act=report"
//               target="_blank"
//               rel="noreferrer"
//               className="link-info fs-6 text-decoration-none"
//             >
//               {"ข่าวกิจกรรมคณะทั้งหมด >>"}
//             </a>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }